import React from "react";
import { Step, Icon } from "semantic-ui-react";

// Define view modes for the wizard steps
export const VIEW_MODES = {
  AUDIT: "audit",
  GROUP: "group",
  INVENTORY: "inventory",
  REVIEW: "review",
  COMPLETED: "completed", // Added completed mode
};

/**
 * A container component that manages the wizard UI and step indicators
 */
const WizardStepsHeader = ({ viewMode, isLoading }) => {
  return (
    <div>
      {/* Step indicators */}
      {!isLoading && (
        <Step.Group fluid>
          <Step
            active={viewMode === VIEW_MODES.AUDIT}
            completed={viewMode !== VIEW_MODES.AUDIT}
          >
            <Icon name="clipboard check" />
            <Step.Content>
              <Step.Title>Audit</Step.Title>
              <Step.Description>Audit and mark items</Step.Description>
            </Step.Content>
          </Step>

          <Step
            active={viewMode === VIEW_MODES.GROUP}
            disabled={viewMode === VIEW_MODES.AUDIT}
            completed={
              viewMode === VIEW_MODES.INVENTORY ||
              viewMode === VIEW_MODES.REVIEW ||
              viewMode === VIEW_MODES.COMPLETED
            }
          >
            <Icon name="object group" />
            <Step.Content>
              <Step.Title>Group</Step.Title>
              <Step.Description>Group selected items</Step.Description>
            </Step.Content>
          </Step>

          <Step
            active={viewMode === VIEW_MODES.INVENTORY}
            disabled={
              viewMode === VIEW_MODES.AUDIT || viewMode === VIEW_MODES.GROUP
            }
            completed={
              viewMode === VIEW_MODES.REVIEW ||
              viewMode === VIEW_MODES.COMPLETED
            }
          >
            <Icon name="boxes" />
            <Step.Content>
              <Step.Title>Inventory</Step.Title>
              <Step.Description>Define inventory details</Step.Description>
            </Step.Content>
          </Step>

          <Step
            active={viewMode === VIEW_MODES.REVIEW}
            disabled={
              viewMode !== VIEW_MODES.REVIEW &&
              viewMode !== VIEW_MODES.COMPLETED
            }
            completed={viewMode === VIEW_MODES.COMPLETED}
          >
            <Icon name="check circle" />
            <Step.Content>
              <Step.Title>Review</Step.Title>
              <Step.Description>Review and submit</Step.Description>
            </Step.Content>
          </Step>

          <Step
            active={viewMode === VIEW_MODES.COMPLETED}
            disabled={viewMode !== VIEW_MODES.COMPLETED}
          >
            <Icon name="flag checkered" />
            <Step.Content>
              <Step.Title>Complete</Step.Title>
              <Step.Description>Process complete</Step.Description>
            </Step.Content>
          </Step>
        </Step.Group>
      )}
    </div>
  );
};

export default WizardStepsHeader;
